import React from "react";

const MyProjectDetailsModal = ({ isOpen, onClose, projectData }) => {
  if (!isOpen || !projectData) return null;

  // Calculate roles from the API payload
  let editorsCount =0 ; // Assume owner acts as an editor
  let reviewersCount = 0;

  if (projectData.shared_to) {
    projectData.shared_to.forEach((user) => {
      if (user.permission === "editor") editorsCount++;
      if (user.permission === "reviewer") reviewersCount++;
    });
  }

  const totalMembers = editorsCount + reviewersCount;

  const webLinks = Array.isArray(projectData.web_links) ? projectData.web_links : [];
  const toHref = (link) => (/^https?:\/\//i.test(link) ? link : `https://${link}`);

  return (
    <div className="fixed inset-0 z-[10000] bg-black/40 backdrop-blur-sm flex items-center justify-center font-outfit">
      <div className="bg-white rounded-2xl shadow-lg w-[700px] px-5 py-4 animate-[fadeIn_0.3s_ease-in-out]">
        {/* Header */}
        <div className="flex justify-between items-center mb-4 mx-1">
          <h2 className="text-[#C95EBE] font-semibold text-[20px]">
            Project Details
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-900 transition-colors"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>

        {/* Content Box */}
        <div className="border border-gray-200 rounded-xl px-5 py-4 mb-2">
          <div className="grid grid-cols-2 gap-y-6">
            <div>
              <p className="text-[#3F3F46] font-medium text-[16px] mb-1">Project Name</p>
              <p className="text-[#3F3F46] text-[15px]">{projectData.name || "_"}</p>
            </div>
            
            <div>
              <p className="text-[#3F3F46] font-medium text-[16px] mb-1">Project Owner</p>
              {/* Both list sources supply `owner`, so shared projects can now name
                  their real owner instead of falling back to a generic label. */}
              <p className="text-[#3F3F46] text-[15px]">
                {projectData.is_owner
                  ? "You"
                  : projectData.owner?.name || projectData.owner?.email || "_"}
              </p>
            </div>

            <div>
              <p className="text-[#3F3F46] font-medium text-[16px] mb-1">Members ({totalMembers})</p>
              <p className="text-[#3F3F46] text-[15px]">
                Editors - {editorsCount} <span className="mx-2 text-gray-300">|</span> Reviewers - {reviewersCount}
              </p>
            </div>

            <div>
              <p className="text-[#3F3F46] font-medium text-[16px] mb-1">Your Role & Permission</p>
              <p className="text-[#3F3F46] text-[15px] capitalize">
                {/* Org admins can see a member's project without being on it. */}
                {projectData.user_permission && projectData.user_permission !== "none"
                  ? projectData.user_permission
                  : "No access"}
              </p>
            </div>

            <div className="col-span-2">
              <p className="text-[#3F3F46] font-medium text-[16px] mb-1">Description</p>
              <p className="text-[#3F3F46] text-[15px] leading-relaxed">
                {projectData.description || "No description provided."}
              </p>
            </div>

            <div className="col-span-2">
              <p className="text-[#3F3F46] font-medium text-[16px] mb-1">Web Links</p>
              {webLinks.length > 0 ? (
                <div className="flex flex-col gap-1 max-h-[160px] overflow-y-auto pr-1">
                  {webLinks.map((link, index) => (
                    <a
                      key={index}
                      href={toHref(link)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#C95EBE] text-[15px] underline break-all hover:text-[#b54eb0] transition-colors"
                    >
                      {link}
                    </a>
                  ))}
                </div>
              ) : (
                <p className="text-[#3F3F46] text-[15px]">No links added.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyProjectDetailsModal;